module.exports = __webpack_public_path__ + "static/media/effect_excellent.0ccc61c4.png";